import axios from '../axios/axios';

export function getPostTopApi(params) {
  return axios.post('/content/getposttop', params);
}
